export default __webpack_public_path__ + "static/media/icon-route-map.9c67c7d2.svg";